import React, { useState } from 'react';

import { useMutation } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';
import { Button, Flash, Modal } from '@betterment/style-closet-react';

import { AppCustomerContext } from './CustomerProvider';

import { refreshLeftNav } from '../../Shared/left-nav-refresher';
import { urlBuilder } from '../../Shared/urlBuilder';
import { Invitation } from '../data';

interface InvitationCancellationModalProps {
  onClose: () => void;
  refreshCustomer: AppCustomerContext['refetch'];
  invitation: Invitation;
}

const InvitationCancellationModal: React.FC<React.PropsWithChildren<InvitationCancellationModalProps>> = ({
  onClose,
  refreshCustomer,
  invitation,
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [didCancellationFailed, setDidCancellationFailed] = useState(false);
  const [cancelInvitation] = useMutation(urlBuilder.postCancelJointCheckingInvitation(invitation.invitationId));

  const clickHandler = async () => {
    setIsDisabled(true);
    try {
      const response = await cancelInvitation();
      if (response.errors) {
        setDidCancellationFailed(true);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        onClose();
        await Promise.all([refreshCustomer(), refreshLeftNav('checking')]);
      }
    } catch (error) {
      setDidCancellationFailed(true);
      setIsDisabled(false);
    }
  };

  return (
    <Modal closeHandler={onClose} contentWidth={['100%', '600px']} label="cancel invite">
      <Modal.Slot name="heading">Cancel your invite?</Modal.Slot>
      <Modal.Slot name="content">
        <Text as="p">{invitation.receiverFirstName} will no longer be able to join your Checking account.</Text>
        {didCancellationFailed && (
          <Box
            css={{
              marginBottom: 'space.300',
            }}
          >
            <Flash variant="error">
              <Text as="p">Something went wrong, please try again.</Text>
            </Flash>
          </Box>
        )}
      </Modal.Slot>
      <Modal.Slot name="actions">
        <Button onClick={clickHandler} disabled={isDisabled}>
          {isDisabled ? 'Cancelling...' : 'Cancel invite'}
        </Button>
      </Modal.Slot>
    </Modal>
  );
};

export default InvitationCancellationModal;
